import React, { useState } from "react";
import { Field } from "formik";
import Select from "react-select";

const SearchInput = ({ label, shouldShowError, placeholder, isLoading, onInput, options, initialSelection = null, ...props }) => {
    const [selectedOption, setSelectedOption] = useState(initialSelection && { label: initialSelection?.name, value: initialSelection?.value });

    const onSelect = (value, setFieldValue) => {
        setSelectedOption(value)
        setFieldValue(props.id || props.name, value?.value || "")
    }

    return (
        <div className="form-group col">
            {label && <label className={"capitalize text-sm"} htmlFor={props.id || props.name}>{label}</label>}
            <Field name={props.id || props.name}>
                {({ meta, form: { setFieldValue } }) => (
                    <>
                        <Select
                            value={selectedOption}
                            onChange={(val) => (onSelect(val, setFieldValue))}
                            options={options?.map(option => ({
                                value: option.value,
                                label: option.name
                            })) ?? []}
                            onInputChange={onInput}
                            isLoading={isLoading}
                            isSearchable={true}
                            isClearable={true}
                            placeholder={placeholder}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    borderRadius: "2rem",
                                    borderColor: "hsl(0, 0%, 90%)",
                                    boxShadow: 0,
                                    '&:hover': {
                                        borderColor: "hsl(0, 0%, 90%)",
                                    }
                                })
                            }}
                        />
                        {shouldShowError || meta.error ? (
                            <div className="text-danger">{meta.error}</div>
                        ) : null}
                    </>
                )}
            </Field>
        </div>
    );
};

export default SearchInput;